import React, { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav, Form, Button } from "react-bootstrap";
import ReactSlider from "react-slider";
import { useLocation } from "react-router-dom"; // <-- for reading URL params
import Sidebar from "./Sidebar";
import ToolsCaption from "./ToolsCaption";
import ToolsIdea from "./ToolsIdea";
import ToolsProfile from "./ToolsProfile";
import ToolsStory from "./ToolsStory";
import ToolsDownload from "./ToolsDownload";
import ToolsTrends from "./ToolsTrends";
import ToolsPhoto from "./ToolsPhoto";
import ToolsCollab from './ToolsCollab';

import axios from "axios";
const Tools = () => {
  const [captionValue, setCaptionValue] = useState(0);
  const [ideaValue, setIdeaValue] = useState(0);
  const [profileValue, setProfileValue] = useState(0);
  const [storyValue, setStoryValue] = useState(0);
  const [downloadValue, setDownloadValue] = useState("");



  const [likesValue, setLikesValue] = useState(0);
  const [viewsValue, setViewsValue] = useState(0);
  const [commentsValue, setCommentsValue] = useState(0);
  const [postLink, setPostLink] = useState("");



  // Read "mode" from query param (?mode=likes/views/comments)
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const modeParam = queryParams.get("mode");

  // We'll ensure it's one of the 3 valid tabs; otherwise default to "likes"
  const validModes = ["caption", "idea", "profile", "trends", "photo", "collab", "story", "download"];
  const defaultKey = validModes.includes(modeParam) ? modeParam : "story";

  // Handler for "Start Delivery"
  const handleStartDelivery = (type) => {
    let selectedValue;
    if (type === "caption") selectedValue = captionValue;
    if (type === "idea") selectedValue = ideaValue;
    if (type === "profile") selectedValue = profileValue;
	if (type === "story") selectedValue = storyValue;
	if (type === "download") selectedValue = downloadValue;

    alert(
      `Starting delivery for ${type}!\nAmount: ${selectedValue}\nPost Link: ${postLink}`
    );
  };






  return (
	<>
	
    <Container className="py-2">
      {/* Header Section 
      <div className="align-items-center mb-4">
        <Col xs={12} md={6}>
          <span className="text-4xl font-bold text-gray-800"><span className="text-instagram">ViralGPT</span> Tools </span>
        </Col>
      </div>*/}

      {/* Tabs Section */}
      <Tab.Container defaultActiveKey={defaultKey}>
        <div className="overflow-x-auto">
          <Nav variant="tabs" className="bg-white border flex flex-nowrap min-w-max rounded" style={{minWidth: "800px"}}>
			  <Nav.Item className="flex-1">
              <Nav.Link eventKey="story" className="h-24 w-full flex flex-col justify-center items-center text-center">
                <div className="text-3xl mb-1">🕵️</div>
                <div className="text-sm">Story Viewer</div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="flex-1">
              <Nav.Link eventKey="download" className="h-24 w-full flex flex-col justify-center items-center text-center">
                <div className="text-3xl mb-1">📥</div>
                <div className="text-sm">Post Downloader</div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="flex-1">
              <Nav.Link eventKey="caption" className="h-24 w-full flex flex-col justify-center items-center text-center">
                <div className="text-3xl mb-1">📝</div>
                <div className="text-sm">Caption Generator</div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="flex-1">
              <Nav.Link eventKey="idea" className="h-24 w-full flex flex-col justify-center items-center text-center">
                <div className="text-3xl mb-1">🧠</div>
                <div className="text-sm">Idea Generator</div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="flex-1">
              <Nav.Link eventKey="profile" className="h-24 w-full flex flex-col justify-center items-center text-center">
                <div className="text-3xl mb-1">🪄</div>
                <div className="text-sm">Profile Enhancer</div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="flex-1">
              <Nav.Link eventKey="trends" className="h-24 w-full flex flex-col justify-center items-center text-center">
                <div className="text-3xl mb-1">🎯</div>
                <div className="text-sm">Trends Analyzer</div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="flex-1">
              <Nav.Link eventKey="photo" className="h-24 w-full flex flex-col justify-center items-center text-center">
                <div className="text-3xl mb-1">📸</div>
                <div className="text-sm">Photo Reviewer</div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="flex-1">
              <Nav.Link eventKey="collab" className="h-24 w-full flex flex-col justify-center items-center text-center">
                <div className="text-3xl mb-1">🤝</div>
                <div className="text-sm">Collab Finder</div>
              </Nav.Link>
            </Nav.Item>
            
          </Nav>
        </div>
        <Tab.Content>
          {/* Caption Tab */}
          <Tab.Pane eventKey="caption" className="border-instagram">
            <ToolsCaption />
          </Tab.Pane>

          {/* Idea Tab */}
          <Tab.Pane eventKey="idea" className="border-instagram">
            <ToolsIdea />
          </Tab.Pane>

          {/* Profile Tab */}
          <Tab.Pane eventKey="profile" className="border-instagram">
            <ToolsProfile />
          </Tab.Pane>

          {/* Trends Tab */}
          <Tab.Pane eventKey="trends" className="border-instagram">
            <ToolsTrends />
          </Tab.Pane>

          <Tab.Pane eventKey="photo" className="border-instagram">
            <ToolsPhoto />
          </Tab.Pane>

          <Tab.Pane eventKey="collab" className="border-instagram">
            <ToolsCollab />
          </Tab.Pane>

          {/* Story Tab */}
          <Tab.Pane eventKey="story" className="border-instagram">
            <ToolsStory />
          </Tab.Pane>

          {/* Download Tab */}
          <Tab.Pane eventKey="download" className="border-instagram">
            <ToolsDownload />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Container>
	</>
  );
};

export default Tools;
